import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();


// Import custom modules
import Example from "./modules/example.js";

if (import.meta.hot) {
    import.meta.hot.accept();
}

window.$ = window.jQuery;
window.jQuery = window.jQuery;

